<template lang="pug">
  div(class="billing-generate-act-form")
    h1(class="title-32px fw-700 mb-2") {{ $t('Generate act') }}
    p(class="text-14px fw-300") {{ $t('Select period for act generation') }}
    v-form(@submit.prevent="downloadReconciliationAct")
      ValidationObserver(ref="form")
        div(class="billing-generate-act-form__content")
          div(class="text-14px mb-3") {{ $t('Quick period selection') }}
          div(class="billing-generate-act-form__buttons")
            v-btn(
              v-for="(button, index) in quickPeriodButtons"
              :key="index"
              class="rounded"
              :class="[selectedQuickPeriod === button.key ? 'secondary-button xs' : 'outlined-button color-neutral']"
              @click="setPeriod(button.key, button.value)"
            ) {{ button.text }}
          div(class="text-14px mb-3") {{ $t('Or specify the period manually') }}
          ValidationProvider(
            v-slot="{ errors }"
            :name="wrapQuotesProviderName($t('Select date range'))"
            rules="required"
          )
            e-input-datetime-range(
              v-model="period"
              :label="$t('Select date range')"
              :error-messages="errors"
              filled
              prepend-icon
              hide-details="auto"
            )
        div(class="two-buttons-wrapper")
          v-btn(
            height="48"
            @click="closeModal"
          ) {{ $t('Cancel') }}
          v-btn(
            class="main-button"
            type="submit"
            :loading="loading"
          ) {{ $t('Download Excel') }}
</template>

<script>
import Download from 'js-file-download'
import EInputDatetimeRange from '~/components/elements/inputs/e-input-datetime-range'
import validate from '~/mixins/validation/validate'
import informationSnackbar from '~/modules/snackbar/mixins/informationSnackbar'
import { getFilenameFromContentDisposition } from '~/services/_utils/utils'

export default {
  name: 'BillingGenerateActForm',
  components: {
    EInputDatetimeRange
  },
  mixins: [validate, informationSnackbar],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    organizationId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      period: null,
      selectedQuickPeriod: null,
      loading: false
    }
  },
  computed: {
    quickPeriodButtons() {
      return [
        {
          key: 'lastMonth',
          text: this.$t('Last month'),
          value: [
            this.$moment().subtract(1, 'month').format('YYYY-MM-DD'),
            this.$moment().format('YYYY-MM-DD')
          ]
        },
        {
          key: 'lastQuarter',
          text: this.$t('Last quarter'),
          value: [
            this.$moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'),
            this.$moment().subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD')
          ]
        },
        {
          key: 'currentYear',
          text: this.$t('Current year'),
          value: [
            this.$moment().startOf('year').format('YYYY-MM-DD'),
            this.$moment().format('YYYY-MM-DD')
          ]
        }
      ]
    }
  },
  methods: {
    async downloadReconciliationAct() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      try {
        this.loading = true
        const response = await this.$store.dispatch('acts/downloadReconciliationAct', {
          dateFrom: this._.get(this.period, '0'),
          dateTo: this._.get(this.period, '1'),
          organizationId: this.organizationId || this.$Organization?.id
        })
        if (response && response.data) {
          const contentDisposition = this._.get(response, 'headers.content-disposition')
          const fileName = getFilenameFromContentDisposition(contentDisposition)
          Download(response.data, fileName)
          this.informationSnackbar.open({
            icon: 'check-circle-white-filled',
            text: this.$t('Act has been generated')
          })
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    },
    setPeriod(key, value) {
      this.period = value
      this.selectedQuickPeriod = key
    }
  }
}
</script>

<style scoped lang="scss">
.billing-generate-act-form {
  &__content {
    padding: 32px 0;
  }
  &__buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;
  }
}
</style>
